export default function Stethoscope({ size = 24 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M13.5 22C11.7 22 10.1667 21.3667 8.9 20.1C7.63333 18.8333 7 17.3 7 15.5V14.925C5.56667 14.6917 4.375 14.0207 3.425 12.912C2.475 11.8033 2 10.4993 2 9V3H5V2H7V6H5V5H4V9C4 10.1 4.39167 11.0417 5.175 11.825C5.95833 12.6083 6.9 13 8 13C9.1 13 10.0417 12.6083 10.825 11.825C11.6083 11.0417 12 10.1 12 9V5H11V6H9V2H11V3H14V9C14 10.5 13.525 11.8043 12.575 12.913C11.625 14.0217 10.4333 14.6923 9 14.925V15.5C9 16.75 9.43767 17.8127 10.313 18.688C11.1883 19.5633 12.2507 20.0007 13.5 20C14.7493 19.9993 15.812 19.562 16.688 18.688C17.564 17.814 18.0013 16.7513 18 15.5V13.825C17.4167 13.625 16.9377 13.2667 16.563 12.75C16.1883 12.2333 16.0007 11.65 16 11C16 10.1667 16.2917 9.45833 16.875 8.875C17.4583 8.29167 18.1667 8 19 8C19.8333 8 20.5417 8.29167 21.125 8.875C21.7083 9.45833 22 10.1667 22 11C22 11.65 21.8127 12.2333 21.438 12.75C21.0633 13.2667 20.584 13.625 20 13.825V15.5C20 17.3 19.3667 18.8333 18.1 20.1C16.8333 21.3667 15.3 22 13.5 22Z"
        fill="currentColor"
      />
    </svg>
  );
}
